import PropTypes from 'prop-types'
import React from 'react'
import ClearInputButton from '#components/a/form/ClearInputButton'

function UserSearchResult({modifier, header, content, resetSearch}) {
  const modifierClass = modifier ? ` userSearchResult--${modifier}` : ''

  return (
    <div className={`userSearchResult${modifierClass}`}>
      {header && <div className="resultRow resultRow--header">{header}</div>}
      <div className="resultRow">
        {content}
        <ClearInputButton onPress={resetSearch} />
      </div>
    </div>
  )
}

UserSearchResult.propTypes = {
  modifier: PropTypes.string,
  resetSearch: PropTypes.func,
  header: PropTypes.node,
  content: PropTypes.node,
}

export default UserSearchResult
